/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetLodgingDoorsSummaryQueryResponse,
  GetLodgingDoorsSummaryQueryParams,
} from '../types/GetLodgingDoorsSummary'

function getGetLodgingDoorsSummaryUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/places/lodging-doors/summary/` as const,
  }
  return res
}

/**
 * @summary Lodging doors summary counts
 * {@link /api/v1/places/lodging-doors/summary/}
 */
export async function getLodgingDoorsSummary(
  params?: GetLodgingDoorsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetLodgingDoorsSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetLodgingDoorsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
